export const preventNavigationIfUnavailable = (event, resolvedUrl) => {
    if (!resolvedUrl) {
        event.preventDefault();
    }
}
